export default __webpack_public_path__ + "static/media/dot.16b004a1.svg";